
import {defineComponent} from 'vue';
import ScreenWrapper from "@/components/elements/ScreenWrapper.vue";
import {useState} from "@/hooks/state";
import {ScreenTextsConfig} from "@/Screens.types";

const state = useState();
export default defineComponent({
  components: {
    ScreenWrapper,
  },
  props: {
    msg: String,
    goTo: Function,
    config: Object as () => ScreenTextsConfig,
  },

  setup() {
    return {
      state
    }
  },
  data() {
    return {
      screen: this.config.screenId,
      selectedImages: {},
    }
  },

  mounted() {
  },

  methods: {
    next() {
      this.goTo(this.config.screenNext)
    },

    openNextLink() {
      window.location.href = this.config.nextButtonLink;
    },

    selectImage(index: string | number, image: any) {
      this.selectedImages[index] = !this.selectedImages[index];
      const answers = Object.keys(this.selectedImages).filter(key => this.selectedImages[key]);

      state.setAnswer(this.config.answerKey, answers, {
        [this.config.answerKey]: this.config.textPart1,
      })
    },
  }
});
